import { create } from 'zustand';

const useApiKeyState = create((set) => ({
    apikey: '',
    setapikey: (newapikey) => set(() => ({ apikey: newapikey })),
}));

export default useApiKeyState;
